var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTools(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.554 2.18a2.333 2.333 0 012.982 2.982l7.23 7.23-1.415 1.415-7.23-7.23A2.333 2.333 0 012.14 3.594l1.49 1.492a1 1 0 101.414-1.414l-1.49-1.493zm6.912 1.256l2.121-1.179.943.943L12.35 5.32l-1.179.236L9.76 6.971l-.943-.943 1.414-1.414.236-1.178zM5.752 8.62l1.414 1.415-3.3 3.3a1 1 0 01-1.478-1.344l.064-.07 3.3-3.3z",
    fill: "#3273FA"
  })));
}
export default __webpack_public_path__ + "static/svg/tools.svg";
export { SvgTools as ReactComponent };